import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lnfmayoxwmidbabrojze.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxuZm1heW94d21pZGJhYnJvanplIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk0NTE1MDUsImV4cCI6MjA2NTAyNzUwNX0.raceTyoB-6c-y6GH5gDDHrY8AeXDxhleSSTkWVs7iSE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY);